import { FileOutlined } from "@ant-design/icons"; // Custom styles
import { Button, Card, Divider, Layout, Space, Typography } from "antd";
import React, { useState } from "react";
import ACHPay from "./ACHPay";
import { LOGO } from "../../../config/Images";
import download from "./assets/down.svg";
import Wire from "./Wire";
import PaymentForm from "./Card";
const { Content } = Layout;
const { Title, Text, Paragraph } = Typography;

const PaymentOpts = () => {
  const [selectedOpt, setSelectedOpt] = useState("ach");
  return (
    <div className="payment-layout">
      <div className="w50">
        {/* Header */}
        <div className="payment-header">
          <img src={LOGO} width={180} />
          <Button
            className="download"
            type="primary"
            icon={<img src={download} width={15} />}
            size="large"
          >
            Download
          </Button>
        </div>

        {/* Payment Info */}
        <div className="payment-card">
          <div className="detail-box">
            <Text
              style={{
                opacity: 0.9,
              }}
            >
              From Santosh Pavan (santoshpavan@zenus.com)
            </Text>
            <Title level={4}>Please complete this payment to Zenus Bank</Title>
          </div>
          <Card className="amount-box" bordered={false}>
            <Title level={2}>$4,484.00</Title>
            <Text>Due Sep 15, 2024</Text>
            <Divider />
            <Paragraph italic>
              “September consulting fees for Sky Project”
            </Paragraph>
          </Card>
        </div>

        {/* Attachments */}
        <div className="attachments-card">
          <Title level={4}>Attachments</Title>
          <div className="attachment-wrap" style={{ width: "100%" }}>
            <div className="attachment-item">
              <Text>
                <FileOutlined />
                ZenusInvoice.pdf
              </Text>
              <Button
                type="primary"
                className="download"
                icon={<img src={download} width={15} />}
              >
                Download
              </Button>
            </div>
            <div className="attachment-item">
              <Text>
                <FileOutlined />
                ZenusReceipt.jpg
              </Text>
              <Button
                type="primary"
                className="download"
                icon={<img src={download} width={15} />}
              >
                Download
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          position: "relative",
        }}
      >
        <Divider type="vertical" />
      </div>
      <div className="w50">
        {/* Bank Details */}
        <div className="bank-details-card">
          <Space className="tabs" size="middle">
            <Button
              className={`${selectedOpt === "ach" ? "active" : ""} download`}
              type="primary"
              onClick={() => {
                setSelectedOpt("ach");
              }}
            >
              ACH / Wire
            </Button>
            <Button
              className={`${selectedOpt === "wire" ? "active" : ""} download`}
              type="primary"
              onClick={() => {
                setSelectedOpt("wire");
              }}
            >
              International Wire
            </Button>
            <Button
              className={`${selectedOpt === "card" ? "active" : ""} download`}
              type="primary"
              onClick={() => {
                setSelectedOpt("card");
              }}
            >
              Card
            </Button>
          </Space>
          {/* Bank Info */}
          {selectedOpt === "ach" && <ACHPay />}
          {selectedOpt === "wire" && <Wire />}
          {selectedOpt === "card" && <PaymentForm />}
        </div>
      </div>
    </div>
  );
};

export default PaymentOpts;
